import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import BrandLogos from "@/components/BrandLogos";

const branches = [
  {
    name: "Style-U — Tambe Nagar",
    sub: "Mulund West",
    phone: "+91 72084 50811",
    tel: "+917208450811",
  },
  {
    name: "Style-U — Veena Nagar",
    sub: "Mulund West",
    phone: "+91 75068 30887",
    tel: "+917506830887",
  },
  {
    name: "7 Hills Unisex Salon",
    sub: "Near Vivek College, Goregaon West",
    phone: "+91 77384 70671",
    tel: "+917738470671",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 pt-24 pb-12 px-6 lg:px-12"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8 pb-20">
          {/* Brand column */}
          <div className="md:col-span-4">
            <p className="label-eyebrow mb-5">The Salons</p>
            <p className="font-serif-display text-3xl md:text-4xl text-white/90 leading-tight max-w-md">
              Three salons, one craftsman's eye — Style-U Veena Nagar,
              Style-U Tambe Nagar & 7 Hills Goregaon West, led by Mr. Suresh
              Bhandari.
            </p>

            <div className="mt-10">
              <p className="label-eyebrow mb-3">Proprietor</p>
              <a
                href="tel:+919820981555"
                data-testid="footer-proprietor-phone"
                className="na-link text-white/90 text-lg"
              >
                Suresh Bhandari · +91 98209 81555
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="md:col-span-2 md:col-start-6">
            <p className="label-eyebrow mb-6">Quick Links</p>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  data-testid="footer-home-link"
                  className="na-link text-white/80 text-sm tracking-[0.15em] uppercase"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  data-testid="footer-services-link"
                  className="na-link text-white/80 text-sm tracking-[0.15em] uppercase"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/owner"
                  data-testid="footer-owner-link"
                  className="na-link text-white/80 text-sm tracking-[0.15em] uppercase"
                >
                  Owner
                </Link>
              </li>
            </ul>
          </div>

          {/* Branches + phones */}
          <div className="md:col-span-5">
            <p className="label-eyebrow mb-6">Visit & Call</p>
            <ul className="space-y-8 text-sm text-white/80">
              {branches.map((b, i) => (
                <li
                  key={b.name}
                  data-testid={`footer-branch-${i}`}
                  className="grid grid-cols-[auto_1fr] gap-3"
                >
                  <MapPin
                    size={16}
                    strokeWidth={1.25}
                    className="text-[#cfa86e] mt-0.5"
                  />
                  <div>
                    <p className="text-white">{b.name}</p>
                    <p className="text-white/60 text-xs mt-0.5">{b.sub}</p>
                    <a
                      href={`tel:${b.tel}`}
                      data-testid={`footer-branch-phone-${i}`}
                      className="mt-2 inline-flex items-center gap-2 text-[#ffd36e] hover:text-white transition-colors"
                    >
                      <Phone size={13} strokeWidth={1.5} />
                      <span className="tracking-wide">{b.phone}</span>
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Brand logos collage */}
        <div className="border-t border-white/10 pt-12">
          <div
            data-testid="footer-wordmark"
            className="flex items-center justify-center md:justify-start"
          >
            <BrandLogos variant="footer" />
          </div>
          <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 text-xs tracking-[0.2em] uppercase text-white/40">
            <span>© {new Date().getFullYear()} Style-U & 7 Hills Unisex Salon</span>
            <span>Crafted by hand. Finished with care.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
